import { getOrCreateContentfulClient } from '@graphql/client'
import type { ArticleKind } from '@graphql/hooks/article-page'
import { GetRecentArticlesByKind } from '@graphql/hooks/article-topic-page'
import { webviewStore } from '@lib/store/ui/webview'
import { TEXT } from '@lib/utils/text'
import { ArticlePageTemplate } from '@page-templates/article-page'
import type { ArticleStaticProps } from '@server/helpers/article'
import { getArticleStaticProps } from '@server/helpers/article'
import { isPrd } from '@shared/util/env'
import { LINK } from '@shared/util/link'
import type { NextPage } from 'next'

const Money101Article: NextPage<ArticleStaticProps> = (props) => {
    return (
        <ArticlePageTemplate
            kind={TEXT.money101}
            breadcrumbs={[
                {
                    text: TEXT.money101,
                    link: LINK.money101(webviewStore.isWebview),
                },
            ]}
            {...props}
        />
    )
}
export const getStaticPaths = async () => {
    const client = getOrCreateContentfulClient(TEXT.money101)

    const kind: ArticleKind = 'Money 101'

    // get popular articles and generate static pages for them
    const { data } = await GetRecentArticlesByKind(client, {
        variables: { kind, count: 25 },
    })

    const paths = data?.articleCollection?.items?.map((article) => ({
        params: { slug: article?.slug },
    }))

    return {
        paths: isPrd() ? paths : [],
        fallback: 'blocking',
    }
}

export const getStaticProps = getArticleStaticProps(TEXT.money101)

export default Money101Article
